import axios from "axios";
export default {
  async Login({ commit }, Form) {
    try {
      let response = await axios.post("/user_login", Form);
      localStorage.setItem("token", response.data.user.api_token)
      localStorage.setItem("user", JSON.stringify(response.data.user));
      axios.defaults.headers.common.Authorization = `Bearer ${response.data.user.api_token}`;
      commit("setUser", { user: response.data.user, token: response.data.user.api_token });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  logout({ commit }) {
    commit("logout");
  },
};
